export default __webpack_public_path__ + "b94e5498b889e3b59c7bcc8592daee5f.png";